import app from 'flarum/forum/app';
import Tooltip from 'flarum/common/components/Tooltip';

import IPInfo from '../models/IPInfo';
import getFlagEmojiUrl from '../util/getFlagEmojiUrl';

export const getDescription = (ipInfo: IPInfo) => {
  return ipInfo.organization() || ipInfo.isp() || ipInfo.error() || '';
};

export const getThreat = (ipInfo: IPInfo) => {
  return ipInfo.threatTypes() || '';
};

export const getFlagImage = (ipInfo: IPInfo) => {
  let countryCode = ipInfo?.countryCode() ?? '', countryName = '';
  if (countryCode.length > 1) {
    const currentLocale = app.translator.getLocale() as string;
    // Create an instance of Intl.DisplayNames for displaying full country names
    const displayNames = new Intl.DisplayNames([currentLocale], { type: 'region' });
    // Get the full country name using the country code
    countryName = displayNames.of(countryCode || '') ?? '';
  }
  // get url of emoji
  const url = getFlagEmojiUrl(countryCode);
  if (url) {
    return (
      <Tooltip text={countryName}>
        <img src={url} alt={countryName} height="18" loading="lazy" />
      </Tooltip>
    );
  }
  return null;
};

export const getIPData = (ipInfo: IPInfo) => {
  const description = getDescription(ipInfo);
  const threat = getThreat(ipInfo);
  const image = getFlagImage(ipInfo);

  const zip = ipInfo.zipCode(); // Extracting zip and country from ipInfo
  const country = ipInfo.countryCode(); // Assuming the country code is used as 'country'

  return { description, threat, image, zip, country };
};
